;(function() {
  'use strict'

  Controller.$inject = ["glAnalytics", "autocompleteService"];
  angular.module('app.survey').component('surveyIntro', {
    controller: Controller,
    templateUrl: 'survey-intro.html',
    bindings: {
      survey: '<',
      intro: '<',
      reward: '<',
    },
  })

  /* @ngInject */
  function Controller(glAnalytics, autocompleteService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.togglePublicDevice = togglePublicDevice

    function onInit() {
      ctrl.intro.isPublicDevice = ctrl.survey.isKiosk
      autocomplete(ctrl.intro.isPublicDevice)
      ctrl.dataDimensions = ctrl.survey.getDimensions(
        ctrl.survey.Dimensions.DATA
      )
    }

    function togglePublicDevice() {
      ctrl.intro.isPublicDevice = !ctrl.intro.isPublicDevice
      autocomplete(ctrl.intro.isPublicDevice)
      glAnalytics.track(
        'survey',
        'toggled-public-device',
        ctrl.intro.isPublicDevice ? 'on' : 'off'
      )
    }

    function autocomplete(isPublicDevice) {
      // Get the stored profile data and autocomplete it
      var storage = isPublicDevice ? null : autocompleteService.getStorage()
      ctrl.survey.autocomplete(storage)
    }
  }
})()
